import React from 'react'

function IconLive ({fill = ''}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" className={fill} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 11.2947C12.284 1.44656 18.8635 1.333 21.4928 2.50724C22.667 5.1365 22.5534 11.716 12.7053 17C12.6031 16.4129 12.0352 14.8749 10.5801 13.4199C9.12512 11.9648 7.58712 11.3969 7 11.2947Z"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 16.8C16.0428 17.7334 16.2609 19.4069 16.5439 21C16.5439 21 20.8223 18.0481 18.0856 14"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.19998 9.99976C6.26664 7.95698 4.59305 7.73887 3 7.45589C3 7.45589 5.95194 3.17741 10 5.91419"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.20864 13.9998C5.57675 14.6317 4.50253 16.4642 5.2608 18.739C7.53562 19.4973 9.36811 18.4231 9.99998 17.7912"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.0948 7.75298C18.0948 6.73278 17.2678 5.90576 16.2476 5.90576C15.2274 5.90576 14.4004 6.73278 14.4004 7.75298C14.4004 8.77317 15.2274 9.6002 16.2476 9.6002C17.2678 9.6002 18.0948 8.77317 18.0948 7.75298Z"  strokeWidth="1.5"/>
    </svg>

  )
}

export default IconLive
